import { Injectable } from '@angular/core';
import { contextPath } from 'site';
import { Observable } from 'rxjs';

import { Http } from '@angular/http';
import { HttpParams } from '@angular/common/http';
import { AvdbSubscription } from './avdb-subscription';
import { SubscriptionResponse } from './subscription-response';

const apiUrl = `${contextPath}/api/subscriptions/avdb`;

@Injectable()
export class AvdbSubscriptionService {
    constructor(private http: Http) {
    }

    getAvdbSubscriptions(
        billingAccountId?: string,
        masterAircraftUuid?: string,
        deviceId?: string,
        includeExpired: boolean = false,
		includeFuture: boolean = false
    ): Observable<AvdbSubscription[]> {
        if (![billingAccountId, masterAircraftUuid, deviceId].some((id) => id != null)) {
            throw new Error('Neither billingAccountId, masterAircraftUuid, nor deviceId were provided');
        }

        let params = new HttpParams().set('includeExpired', String(includeExpired));

		params = params.set('includeFuture', String(includeFuture));

        if (billingAccountId != null) {
            params = params.set('billingAccountId', billingAccountId);
        }

        if (masterAircraftUuid != null) {
            params = params.set('masterAircraftUuid', masterAircraftUuid);
        }

        if (deviceId != null) {
            params = params.set('deviceId', deviceId);
        }

        return this.http.get(apiUrl, {params: params.toString()})
			.map(response => {
				if (response.json().data != null) {
					return response.json().data.map((subscription: any) => AvdbSubscription.fromJSON(subscription));
				} else {
					return [];
				}
			});
    }

    cancelAllSubscriptionsForAircraft(masterAircraftUuid: string): Observable<Array<SubscriptionResponse>> {
    	return this.http.delete(`${apiUrl}/cancel-aircraft-subscriptions/${masterAircraftUuid}`)
			.map(response => response.json().map((job: Array<any>) => SubscriptionResponse.fromJSON(job)));
	}

    cancelAllSubscriptionForDevice(deviceId: string): Observable<Array<SubscriptionResponse>> {
        return this.http.delete(`${apiUrl}/cancel-device-subscriptions/${deviceId}`)
			.map(response => response.json().map((job: Array<any>) => SubscriptionResponse.fromJSON(job)));
    }

    deviceHasActiveNonAircraftSubscriptions(deviceId: string): Observable<Boolean> {
		return this.http.get(`${apiUrl}/${deviceId}/has-non-aircraft-subscriptions`)
			.map(response => response.json().hasActiveDatabaseSubscriptions as Boolean);
	}
}
